module.exports = __webpack_public_path__ + "static/media/PD_03.d5ff7b99.jpg";